import React, { Component } from 'react'
import CardPartido from '../CardPartido'
import Submenu from '../SubmenuFases'
import EliminatoriasContent from '../EliminatoriasContent'
import SemifinalContent from '../SemifinalContent'
import FinalContent from '../FinalContent'
import './_styles.scss'
import Translator from '../../../../../requests/apa/Translator.js'
import Utils from '../../../../../utils/Utils.js'
import { 
  ELIMINATION_PHASES,
  SEMIFINAL,
  FINAL,
  FASES_DE_GRUPOS
} from '../../../constants.js'

/**
* FasesContent
* Main content panel (Figma: 1544x664px)
* Contains:
*  - SubmenuGrupos: secondary group tabs (only when phase === 'fase-de-grupos')
*  - Group columns: each with a date header and 1-2 CardPartido
*
* Nota: los chevrones de navegación son responsabilidad del padre (Mundial2026)
* y se posicionan sobre este panel para garantizar z-index superior al overlay.
*
* Props:
*  - phase          {string}   Current active phase id (e.g. 'fase-de-grupos')
*  - groups         {array}    Array of groups to display:
*                              [ { id, label, fecha, date, matches: [ { ... } ] } ]
*  - subGroups      {array}    Submenu group tabs (only for fase-de-grupos)
*  - activeGroup    {string}   Active group tab id (for SubmenuGrupos)
*  - focusedGroup   {string}   Focused group tab id
*  - focusedChevron {string}   'left' | 'right' | null — chevron con foco
*  - onGroupChange  {function} Group tab change handler
*/

class FasesContent extends Component {

  constructor(props) {
    super(props)
    this.state = { containerFocused: false }
  }

  renderGroup (group, index) {
    const { focusedCard, path, liveEventsMap, liveScoresMap, lineupsMap } = this.props
    let lastDate = null


    return (
      <div key={group.id || index} className='fases-content__group'>
        {/* Date header */}
        <div className='fases-content__group-header'>
          <p className='fases-content__group-fecha'>{Utils.cutPlayerString(Translator.get(`eventodeportivo_carruseletapas_texto_parrafo${index+1}`), 8)}</p>
        </div>

        {/* Match cards */}
        <div className='fases-content__group-matches'>
          {group.matches && group.matches.map((match, matchIdx) => {
            const matchDate = match.scheduledAt ? match.scheduledAt : null
            const showDate = matchDate && matchDate !== lastDate
            const dateGroupLabel = showDate ? Utils.cutPlayerString(match.scheduledAt, 16) : ''
            if (showDate) lastDate = matchDate
            const normalizedId = match.id || match.matchId
            return (
              <div key={normalizedId || matchIdx} className='fases-content__match-wrapper'>
                <p className='fases-content__group-date'>{dateGroupLabel}</p>
                <CardPartido
                  time={match.time}
                  timezone={match.timezone}
                  homeTeam={match.homeTeam}
                  awayTeam={match.awayTeam}
                  venue={match.venue}
                  matchId={normalizedId}
                  isFocused={focusedCard === (normalizedId || `${index}-${matchIdx}`)}
                  status={match.status}
                  broadcast={match.broadcast}
                  matchProgress={match.matchProgress}
                  date={matchDate}
                  liveEvents={liveEventsMap && liveEventsMap[normalizedId]}
                  liveScore={liveScoresMap && liveScoresMap[normalizedId]}
                  path={path}
                  lineups={lineupsMap && lineupsMap[normalizedId]}
                />
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  render () {
    const {
      phase,
      nextPhase,
      matches,
      filters,
      activeTab,
      onTabChange,
      panelFocused,
      results,
      navigation,
      nextMatches,
      finalMatch,
      thirdPlaceMatch,
      liveEventsMap,
      liveScoresMap,
      path
    } = this.props

    const isFaseDeGrupos = phase === FASES_DE_GRUPOS
    const isSemifinal = phase === SEMIFINAL
    const isElimination = ELIMINATION_PHASES.includes(phase)
    const { containerFocused } = this.state
    const isFocused = containerFocused || panelFocused
    const isFinal = phase === FINAL

    const maxCaracters = isFaseDeGrupos ? 1 : undefined

    const tabNavigation = { 'data-sn-down': '.card-partido, .partidos__chevron-phase1 .focusable' }

    return (
      <div 
        className={`fases-content ${isFocused ? 'fases-content--focused' : ''}`}
        onFocus={ () => this.setState({ containerFocused: true }) }
        onBlur={ () => this.setState({ containerFocused: false }) }
      >
        {/* ── Fase de grupos: group submenu ── */}

        <div className='fases-content__submenu-grupos'>
          <Submenu
            tabs={filters}
            activeTab={activeTab}
            onNavigate={onTabChange}
            getActiveLabel={(tab) => tab.roundLongName ? Utils.cutPlayerString(tab.roundLongName, 8) : tab.label}
            classNames={{
              tab: phase === FASES_DE_GRUPOS ? 'group-phases-tabs' : 'grupo-tab',
              active: 'group-phases--active-not-focused',
            }}
            maxCaracters={maxCaracters}
            itemDataOptions={tabNavigation}
          />
        </div>

        {isFinal && (
          <div className='fases-content__final-area'>
            <FinalContent 
              phase={phase}
              matches={matches} 
              results={results} 
              thirdPlaceMatch={thirdPlaceMatch} 
              liveEventsMap={liveEventsMap}
              liveScoresMap={liveScoresMap}
              path={path}
              liveScoresMap={liveScoresMap}
            />
          </div>
        )}

        {isElimination && (
          <div className='fases-content__eliminatorias-area'>
            <EliminatoriasContent 
              phase={phase} 
              nextPhase={nextPhase}
              matches={matches} 
              navigation={navigation} 
              nextMatches={nextMatches} 
              liveEventsMap={liveEventsMap}
              liveScoresMap={liveScoresMap}
              path={path}
              liveEventsMap={liveEventsMap}
              liveScoresMap={liveScoresMap}
            />
          </div>
        )}

        {isSemifinal && (
          <div className='fases-content__semifinal-area'>
            <SemifinalContent 
              phase={phase} 
              matches={matches} 
              thirdPlaceMatch={thirdPlaceMatch} 
              finalMatch={finalMatch} 
              liveEventsMap={liveEventsMap}
              liveScoresMap={liveScoresMap}
              path={path}
              liveEventsMap={liveEventsMap}
              liveScoresMap={liveScoresMap}
            />
          </div>
        )}

        {!isElimination && !isSemifinal && !isFinal && (
          <div className={`fases-content__groups`}>
            {matches && matches.reduce((acc, group, index) => {
              if (index > 0) {
                acc.push(<span key={`divisor-${index}`} className='fases-content__divisor' />)
              }
              acc.push(this.renderGroup(group, index))
              return acc
            }, [])}
          </div>
        )}
      </div>
    )
  }
}

export default FasesContent
 


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Partidos/Components/FasesContent/index.jsx